import PaidIcon from "@mui/icons-material/Paid";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { PayrollSettingInit } from "./PayrollSettingsInit";


export const PayrollHeader = ({
	buttonRef, settingRef,
	handleSetting, showSetting,
	generateDownloadTemplate,
	generateDownloadAdjustmentTemplate,
	openUploadFormHandleClick,
	openRevertPayrollForm,
	openProcessPayrollForm,
	openPostPayrollForm,
	setSettingType,
  showGeneralMessage
}) => {

	return (
		<div className="payrollHeader row">
			<div
				style={{ width: "70%", color: "#668fca" }}
				className="payroll-title row"
			>
				<PaidIcon style={{ padding: "0 10px 0 0" }} />
				<h3>Process Payroll</h3>
			</div>
			<div style={{ width: "30%", textAlign: "right" }}>
				<button
					ref={buttonRef}
					onClick={handleSetting}
					title="Setting"
					type="button"
					className="setting"
				>
					<SettingsIcon />
					<KeyboardArrowDownIcon id="setting-icon" />
				</button>
				<div ref={settingRef}>
					{showSetting && (
						<PayrollSettingInit
							generateDownloadTemplate={generateDownloadTemplate}
							generateDownloadAdjustmentTemplate={generateDownloadAdjustmentTemplate}
							openUploadFormHandleClick={openUploadFormHandleClick}
							openRevertPayrollForm={openRevertPayrollForm}
							openProcessPayrollForm={openProcessPayrollForm}
							openPostPayrollForm={openPostPayrollForm}
							setSettingType={setSettingType}
              showGeneralMessage={showGeneralMessage}
						/>
					)}
				</div>
			</div>
		</div>
	);
};